import $ from 'jquery';
import _ from 'underscore';
import Backbone from "backbone";
import Chaplin from "chaplin";
import HomeMenuPanelView from "views/homeMenuPanel/HomeMenuPanelView";
import CordovaHelper from "models/helper/CordovaHelper";
import PersistentModels from "services/PersistentModels";
import Utils from "models/helper/Utils";
import PlayerService from "services/PlayerService";
import TrebbleClientAPIHelper from "models/helper/TrebbleClientAPI";
import GoogleAnalyticsEvents from "models/helper/GoogleAnalyticsEvents";
import LocalStorageHelper from "models/helper/LocalStorageHelper";
import LiveChatWidgetHelper from "models/helper/LiveChatWidgetHelper";
import SubscriptionManager from "models/helper/SubscriptionManager";
import RolloutHelper from "models/helper/FeatureRolloutHelper";
import { shouldShowUpgradeCTA, getRecommendedUpgradeMode } from "models/helper/WorkspaceUpgradeCTA";
import { TRANSITION_MODES } from "models/helper/WorkspaceTransitionStrategy";
import ti18n from 'i18n!nls/HomeMenuPaneli18n';
import RSVP from "rsvp";

const Rollout = RolloutHelper.getInstance();
const DISPLAY_HOME_MENU  = Rollout.isFeatureEnabled(Rollout.FEATURES.ADD_MY_FEED_PAGE);
const ENABLE_TREBBLE_PLUS_SUB = Rollout.isFeatureEnabled(Rollout.FEATURES.ENABLE_TREBBLE_PLUS_SUB);
const ENABLE_JOURNEY_CREATION = Rollout.isFeatureEnabled(Rollout.FEATURES.ENABLE_JOURNEY_CREATION);
// Default to ON so the workspace UI runs even when Optimizely doesn't have
// the flag entry. Optimizely can still gate per-environment.
const WORKSPACE_ENABLED = Rollout.isFeatureEnabled(Rollout.FEATURES.WORKSPACE_ENABLED, true);
const HomeMenuPanelController = Chaplin.Controller.extend({

    initialize : function(options) {
        _.extend(this, Backbone.Events);
        if (options) {

        }
        this._handleWorkspaceLibraryUpdated = this._handleWorkspaceLibraryUpdated.bind(this);
        if (typeof window !== "undefined" && window.addEventListener) {
            window.addEventListener("trebble:workspace-library-updated", this._handleWorkspaceLibraryUpdated);
        }
        //LocalStorageHelper.getInstance().registerForUserInfoChange("HomeMenuPanelController",this.onUserInfoChanged.bind(this));
        this.listenTo(LocalStorageHelper.getInstance(),LocalStorageHelper.getInstance().eventTypes.USER_INFO_UPDATED, this.onUserInfoChanged.bind(this));
        this.listenTo(SubscriptionManager.getInstance(),SubscriptionManager.getInstance().eventTypes.ON_SUBSCRIPTION_UPDATED, this.onUserSubscriptionChanged.bind(this));
        const userInfoJson= LocalStorageHelper.getInstance().getUserInfo();
        this._userInfo =  userInfoJson?Utils.getInstance().getModelFromUserJson(userInfoJson):null;
        this._allNotificationRead =  true;
        this._unreadMessagesInHelpSection = false;
        this._preferDefaultWorkspaceOnLoad = true;
    },

    onUserInfoChanged :function(newUserInfoJson){
        this._userInfo = newUserInfoJson?Utils.getInstance().getModelFromUserJson(newUserInfoJson):null;
        if(this.view != null){
            this.view.updateUserInfo(this._userInfo);
            if(WORKSPACE_ENABLED){
                this._showWorkspaceSwitcherIfNeeded();
                this._updateNavItemsForContext(LocalStorageHelper.getInstance().getCurrentWorkspaceId());
            }
        }
    },

    _handleWorkspaceLibraryUpdated : function(event){
        if (!WORKSPACE_ENABLED) {
            return;
        }
        if (!this.view) {
            return;
        }
        var preservedWorkspaceContext = event && event.detail
            ? event.detail.preservedWorkspaceContext || null
            : null;
        if (preservedWorkspaceContext && preservedWorkspaceContext.workspaceId) {
            this._preferDefaultWorkspaceOnLoad = false;
        }
        this._loadWorkspaces(preservedWorkspaceContext);
    },

    _handlePanelOpened : function(){
        if (!WORKSPACE_ENABLED || !this.view) {
            return;
        }
        var localStorageHelper = LocalStorageHelper.getInstance();
        var cachedWorkspaceContext = this._getCachedWorkspaceContext();
        if (cachedWorkspaceContext && cachedWorkspaceContext.workspaceId) {
            this._workspaces = localStorageHelper.mergeWorkspaceListWithContext(
                this._workspaces || localStorageHelper.getWorkspaceList() || [],
                cachedWorkspaceContext
            );
            this._showWorkspaceSwitcherIfNeeded();
            this._updateNavItemsForContext(cachedWorkspaceContext.workspaceId);
        }
        if (!localStorageHelper.isLoggedInUserAListener() || cachedWorkspaceContext) {
            this._loadWorkspaces();
        }
    },

    onUserSubscriptionChanged : function(productInfo){
        const showUpgradeBtnInFloatingMenu = Rollout.getFeatureVariable(Rollout.FEATURES.ENABLE_TREBBLE_PLUS_SUB, Rollout.FEATURES.ENABLE_TREBBLE_PLUS_SUB.variables.show_upgrade_btn_in_floating_menu, false);
        if(showUpgradeBtnInFloatingMenu && ENABLE_TREBBLE_PLUS_SUB && SubscriptionManager.getInstance().isPaidAccountSubscriptionOrderAvailable()){
            return SubscriptionManager.getInstance().isCurrentUserSubscribedToTrebblePlus(false, productInfo? true:false).then((function(isSubscribedToTrebblePlus){
                if(isSubscribedToTrebblePlus){
                    this.view.hideUpgradeBtn();
                }else{
                    this.view.showUpgradeBtn();
                }
            }).bind(this))
        }else{
            this.view.hideUpgradeBtn();	
        }
    },

    dispose : function(){
        if (this._handleWorkspaceLibraryUpdated && typeof window !== "undefined" && window.removeEventListener) {
            window.removeEventListener("trebble:workspace-library-updated", this._handleWorkspaceLibraryUpdated);
        }
        Chaplin.Controller.prototype.dispose.call(this);
    },

    showGlobalSearch : function(){
        PersistentModels.getInstance().getRouter().showGlobalSearchPage(null, true);
    },

    showHelpAndFeedback : function(){
        PersistentModels.getInstance().getRouter().showHelpAndFeedback(null, true);
    },

    showExplorePage : function(){
        PersistentModels.getInstance().getRouter().showExplorePage(null, true);
    },

    showOnAirPage : function(){
        PersistentModels.getInstance().getRouter().showOnAirPage(true);
    },

    showMyLibrary : function(){
        PersistentModels.getInstance().getRouter().showMyLibraryPage(null,null, true);
    },

    showMyLibrary2 : function(){
        PersistentModels.getInstance().getRouter().showMyLibrary2Page(true);
    },

    showProjectsPage : function(){
        LocalStorageHelper.getInstance().setWorkspaceProjectFilter(null);
        this._notifyWorkspaceLibraryUpdated();
        // Projects uses the same route as My Library 2
        PersistentModels.getInstance().getRouter().showMyLibrary2Page(true);
    },

    showAssetsPage : function(){
        PersistentModels.getInstance().getRouter().showAssetsPage(true);
    },

    showRecordingsPage : function(){
        PersistentModels.getInstance().getRouter().showRecordingsPage(true);
    },

    showCreateWorkspace : function(){
        if (!WORKSPACE_ENABLED) {
            return;
        }
        // The same CTA slot can mean "Upgrade Plan" or "New Workspace".
        // Free/non-paying users upgrade their personal workspace in place;
        // users who already own any paid workspace create an additional one.
        var mode = this._getWorkspaceSwitcherMode();
        PersistentModels.getInstance().getRouter().showUpgradeToTeamPopup(this, { mode: mode });
    },

    showTranscribedFiles : function(){
        PersistentModels.getInstance().getRouter().showTranscribedFilesPage(true);
    },

    showEditHistory : function(){
        PersistentModels.getInstance().getRouter().showEditHistoryPage(true);
    },

    showReferPage : function(){
        PersistentModels.getInstance().getRouter().showReferralPage(null, true);
    },

    showPlaylistPodcastPage : function(){
        PersistentModels.getInstance().getRouter().showPlaylistPodcasts( true);
    },

    showMySubscriptionsPage : function(){
        PersistentModels.getInstance().getRouter().showMySubscriptionsPage( true);
    },

    showMyJourneysPage : function(){
        PersistentModels.getInstance().getRouter().showMyJourneysPage( true);
    },

    showMyPersonalRadioDetailPage : function(){
        PersistentModels.getInstance().getRouter().showMyPersonalTrebbleDetailPage(true);
    },

    showHomePage : function(){
        PersistentModels.getInstance().getRouter().showNewHomePage( true);
    },

    getModel : function() {
        return this.model;
    },

    getView : function() {
        return this.view;
    },

    showSettingsPage : function(){
        this.view.setSettingsPageAsSelectedMenu();
        PersistentModels.getInstance().getRouter().showSettingsPage(true);
    },

    showfeedsAndNotificationPage : function(){
        PersistentModels.getInstance().getRouter().showFeedAndNotificationPage(true);
    },

    showCapsulesPage : function(){
        PersistentModels.getInstance().getRouter().showCapsulesPage(true);
    },

    showSharedWithMePage : function(){
        PersistentModels.getInstance().getRouter().showSharedWithMePage(true);
    },

    _checkIfUserHasSharedProjects : function(){
        var currentWorkspaceId = LocalStorageHelper.getInstance().getCurrentWorkspaceId();
        if(!this._isPersonalWorkspaceContext(currentWorkspaceId)){
            this.view.hideSharedWithMeMenuBtn();
        }else{
            this.view.showSharedWithMeMenuBtn();
        }
    },

    _loadWorkspaces : function(preservedWorkspaceContext){
        TrebbleClientAPIHelper.getInstance().getMyWorkspaces().then((function(workspaces){
            var localStorageHelper = LocalStorageHelper.getInstance();
            var hasPreservedWorkspaceContext = !!(preservedWorkspaceContext && preservedWorkspaceContext.workspaceId);
            var currentWorkspaceContext = preservedWorkspaceContext || this._getCachedWorkspaceContext();
            var nextWorkspaceList = workspaces || [];
            if (hasPreservedWorkspaceContext) {
                nextWorkspaceList = localStorageHelper.mergeWorkspaceListWithContext(nextWorkspaceList, currentWorkspaceContext);
            } else if (currentWorkspaceContext && currentWorkspaceContext.workspaceId) {
                nextWorkspaceList = nextWorkspaceList.map(function(workspace) {
                    if (!workspace || workspace.workspaceId !== currentWorkspaceContext.workspaceId) {
                        return workspace;
                    }
                    return Object.assign({}, workspace, {
                        isLastSelectedWorkspace: !!currentWorkspaceContext.isLastSelectedWorkspace
                    });
                });
            }
            // Always store and show the switcher so the personal workspace slot stays accessible.
            localStorageHelper.setWorkspaceList(nextWorkspaceList);
            this._workspaces = nextWorkspaceList;

            var defaultWorkspace = this._getDefaultWorkspace();
            // If the current workspace context refers to a workspace the user
            // is no longer a member of (e.g. removed or left), clear it and
            // fall back to personal space.
            var currentWorkspaceId = localStorageHelper.getCurrentWorkspaceId();
            if (!currentWorkspaceId && hasPreservedWorkspaceContext) {
                currentWorkspaceId = currentWorkspaceContext.workspaceId;
                localStorageHelper.setWorkspaceContext(currentWorkspaceContext);
            }
            var currentWorkspaceStillMember = currentWorkspaceId ? nextWorkspaceList.some(function(w) {
                return w.workspaceId === currentWorkspaceId;
            }) : false;
            var currentWorkspaceWasLastSelected = currentWorkspaceId ? nextWorkspaceList.some(function(w) {
                return w && w.workspaceId === currentWorkspaceId && w.isLastSelectedWorkspace;
            }) : false;
            var lastSelectedWorkspace = (!currentWorkspaceId && !defaultWorkspace) ? nextWorkspaceList.find(function(w) {
                return w && w.workspaceId && w.isLastSelectedWorkspace;
            }) : null;
            if (
                !hasPreservedWorkspaceContext &&
                lastSelectedWorkspace
            ) {
                this._setWorkspaceContextFromSummary(lastSelectedWorkspace);
                localStorageHelper.setWorkspaceProjectFilter(null);
                currentWorkspaceId = lastSelectedWorkspace.workspaceId;
                this._preferDefaultWorkspaceOnLoad = false;
                this._notifyWorkspaceLibraryUpdated();
            } else if (
                !hasPreservedWorkspaceContext &&
                defaultWorkspace &&
                (
                    (this._preferDefaultWorkspaceOnLoad && !currentWorkspaceWasLastSelected) ||
                    !currentWorkspaceId ||
                    !currentWorkspaceStillMember
                )
            ) {
                this._setWorkspaceContextFromSummary(defaultWorkspace);
                localStorageHelper.setWorkspaceProjectFilter(null);
                currentWorkspaceId = defaultWorkspace.workspaceId;
                this._preferDefaultWorkspaceOnLoad = false;
                this._notifyWorkspaceLibraryUpdated();
            } else if (currentWorkspaceId) {
                if (!currentWorkspaceStillMember) {
                    localStorageHelper.setWorkspaceContext(null);
                    localStorageHelper.setWorkspaceProjectFilter(null);
                    this._notifyWorkspaceLibraryUpdated();
                } else {
                    var refreshedWorkspace = nextWorkspaceList.find(function(w) {
                        return w.workspaceId === currentWorkspaceId;
                    });
                    if (refreshedWorkspace) {
                        localStorageHelper.setWorkspaceContext(refreshedWorkspace);
                    }
                }
            }

            this._showWorkspaceSwitcherIfNeeded();
            this._updateNavItemsForContext(currentWorkspaceId);
        }).bind(this)).catch((function(error){
            console.error("Error loading workspaces:", error);
            // Even on failure, show the switcher so the personal workspace slot is accessible.
            var localStorageHelper = LocalStorageHelper.getInstance();
            var currentWorkspaceContext = preservedWorkspaceContext || this._getCachedWorkspaceContext();
            var cachedWorkspaceList = this._workspaces || localStorageHelper.getWorkspaceList() || [];
            this._workspaces = currentWorkspaceContext
                ? localStorageHelper.mergeWorkspaceListWithContext(cachedWorkspaceList, currentWorkspaceContext)
                : cachedWorkspaceList;
            this._showWorkspaceSwitcherIfNeeded();
            this._updateNavItemsForContext(LocalStorageHelper.getInstance().getCurrentWorkspaceId());
        }).bind(this));
    },

    _getWorkspaceById : function(workspaceId){
        if(!workspaceId || !this._workspaces){
            return null;
        }
        return this._workspaces.find(function(workspace){
            return workspace && workspace.workspaceId === workspaceId;
        }) || null;
    },

    _isDefaultPersonalWorkspaceSummary : function(workspace){
        return !!(workspace &&
            (workspace.isDefaultPersonalWorkspace === true || workspace.isDefaultWorkspace === true) &&
            workspace.myRole === "owner");
    },

    _getDefaultWorkspace : function(){
        var workspaces = this._workspaces || [];
        return workspaces.find(this._isDefaultPersonalWorkspaceSummary.bind(this)) || null;
    },

    _isDefaultPersonalWorkspaceId : function(workspaceId){
        var workspace = this._getWorkspaceById(workspaceId);
        if(!workspace){
            var context = LocalStorageHelper.getInstance().getWorkspaceContext();
            if(context && context.workspaceId === workspaceId){
                workspace = context;
            }
        }
        return this._isDefaultPersonalWorkspaceSummary(workspace);
    },

    _isPersonalWorkspaceContext : function(workspaceId){
        return !workspaceId || this._isDefaultPersonalWorkspaceId(workspaceId);
    },

    _hasWorkspaceMembershipContext : function(){
        var localStorageHelper = LocalStorageHelper.getInstance();
        if(localStorageHelper.getCurrentWorkspaceId()){
            return true;
        }
        var workspaceList = [];
        try {
            workspaceList = localStorageHelper.getWorkspaceList() || [];
        } catch (error) {
            workspaceList = [];
        }
        return workspaceList.some((function(workspace){
            return workspace && !this._isDefaultPersonalWorkspaceSummary(workspace);
        }).bind(this));
    },

    _getCachedWorkspaceContext : function(){
        var context = null;
        try {
            context = LocalStorageHelper.getInstance().getWorkspaceContext();
        } catch (error) {
            context = null;
        }
        if(context && context.workspaceId){
            return context;
        }
        try {
            var rawContext = window.localStorage ? window.localStorage.getItem("workspaceContext") : null;
            context = rawContext ? JSON.parse(rawContext) : null;
            return context && context.workspaceId ? context : null;
        } catch (error) {
            return null;
        }
    },

    _setWorkspaceContextFromSummary : function(workspace){
        if(!workspace){
            LocalStorageHelper.getInstance().setWorkspaceContext(null);
            return;
        }
        LocalStorageHelper.getInstance().setWorkspaceContext(Object.assign({}, workspace, {
            workspaceId: workspace.workspaceId,
            workspaceName: workspace.workspaceName,
            myRole: workspace.myRole,
            isAdmin: workspace.isAdmin,
            workspaceStatus: workspace.workspaceStatus,
            planType: workspace.planType
        }));
    },

    _showWorkspaceSwitcherIfNeeded : function(){
        // Always show the workspace switcher so the personal workspace slot stays visible.
        var localStorageHelper = LocalStorageHelper.getInstance();
        var activeWorkspaceId = localStorageHelper.getCurrentWorkspaceId();
        var cachedWorkspaceContext = this._getCachedWorkspaceContext();
        if(cachedWorkspaceContext && cachedWorkspaceContext.workspaceId){
            this._workspaces = localStorageHelper.mergeWorkspaceListWithContext(this._workspaces || [], cachedWorkspaceContext);
            activeWorkspaceId = activeWorkspaceId || cachedWorkspaceContext.workspaceId;
        }
        this.view.showWorkspaceSwitcher(
            this._workspaces || [],
            activeWorkspaceId,
            this._onWorkspaceSwitch.bind(this),
            this._onCreateWorkspace.bind(this),
            this._getWorkspaceSwitcherActionLabel()
        );
    },

    _getWorkspaceSwitcherMode : function(){
        if (!shouldShowUpgradeCTA()) {
            return TRANSITION_MODES.CREATE;
        }
        return getRecommendedUpgradeMode();
    },

    _getWorkspaceSwitcherActionLabel : function(){
        if (this._getWorkspaceSwitcherMode() === TRANSITION_MODES.UPGRADE_IN_PLACE) {
            return window.getI18n(ti18n, "UPGRADE_PLAN");
        }
        return window.getI18n(ti18n, "NEW_WORKSPACE");
    },

    _onCreateWorkspace : function(){
        this.showCreateWorkspace();
    },

    _notifyWorkspaceLibraryUpdated : function(){
        if(typeof window !== "undefined" && window.dispatchEvent){
            window.dispatchEvent(new CustomEvent("trebble:workspace-library-updated"));
        }
    },

    _onWorkspaceSwitch : function(workspaceId){
        this._preferDefaultWorkspaceOnLoad = false;
        if(workspaceId){
            // Switching to a workspace
            var workspace = this._workspaces.find(function(w){ return w.workspaceId === workspaceId; });
            if(!workspace){
                return RSVP.resolve();
            }
            return TrebbleClientAPIHelper.getInstance().switchWorkspace({workspaceId: workspaceId}).then((function(){
                LocalStorageHelper.getInstance().setWorkspaceContext(Object.assign({}, workspace, {
                    workspaceId: workspace.workspaceId,
                    workspaceName: workspace.workspaceName,
                    myRole: workspace.myRole,
                    isAdmin: workspace.isAdmin,
                    workspaceStatus: workspace.workspaceStatus,
                    planType: workspace.planType
                }));
                LocalStorageHelper.getInstance().setWorkspaceProjectFilter(null);
                this._updateNavItemsForContext(workspaceId);
                // Update the switcher UI to reflect the new active workspace
                this.view.updateWorkspaceSwitcher(
                    this._workspaces,
                    workspaceId,
                    this._onWorkspaceSwitch.bind(this),
                    this._getWorkspaceSwitcherActionLabel()
                );
                this._notifyWorkspaceLibraryUpdated();
                // Reload content to show workspace projects
                PersistentModels.getInstance().getRouter().showMyLibrary2Page(true);
                this.view.setProjectsPageAsSelectedMenu();
            }).bind(this)).catch(function(error){
                console.error("Error switching workspace:", error);
                window.alertErrorMessage(error);
            });
        }else{
            // Switching to personal space
            return TrebbleClientAPIHelper.getInstance().switchWorkspace({workspaceId: null}).then((function(){
                LocalStorageHelper.getInstance().setWorkspaceContext(null);
                LocalStorageHelper.getInstance().setWorkspaceProjectFilter(null);
                this._updateNavItemsForContext(null);
                // Update the switcher UI
                this.view.updateWorkspaceSwitcher(
                    this._workspaces,
                    null,
                    this._onWorkspaceSwitch.bind(this),
                    this._getWorkspaceSwitcherActionLabel()
                );
                this._notifyWorkspaceLibraryUpdated();
                // Reload content to show personal projects
                PersistentModels.getInstance().getRouter().showMyLibrary2Page(true);
                this.view.setProjectsPageAsSelectedMenu();
            }).bind(this)).catch(function(error){
                console.error("Error switching to personal space:", error);
                window.alertErrorMessage(error);
            });
        }
    },

    _updateNavItemsForContext : function(workspaceId){
        if(workspaceId && !this._isPersonalWorkspaceContext(workspaceId)){
            // Update workspace context label
            var workspace = this._workspaces ? this._workspaces.find(function(w){ return w.workspaceId === workspaceId; }) : null;
            if(workspace && this.view.setWorkspaceContextLabel){
                this.view.setWorkspaceContextLabel(workspace.workspaceName);
            }
        }else{
            if(this.view.setWorkspaceContextLabel){
                this.view.setWorkspaceContextLabel(null);
            }
            this.view.showSharedWithMeMenuBtn();
        }
        this._updateMenuForUserTypeAndContext();
    },

    _updateMenuForUserTypeAndContext : function(){
        var localStorageHelper = LocalStorageHelper.getInstance();
        var isShortcastCreator = localStorageHelper.isLoggedInUserAShortcastreator();
        var isJourneyCreator = localStorageHelper.isLoggedInUserAJourneyCreator();
        var isCreator = localStorageHelper.isLoggedInUserACreator();
        var isListener = localStorageHelper.isLoggedInUserAListener();
        var isLegacyCreator = isJourneyCreator || isCreator;
        var inWorkspace = !this._isPersonalWorkspaceContext(localStorageHelper.getCurrentWorkspaceId());

        if(!WORKSPACE_ENABLED){
            // Workspace feature is OFF — render identical UI to master branch.
            // Neutralize all new wrapper-div styling via CSS class.
            // Also clear any persisted workspace state so users who had a
            // workspace active before the flag was disabled don't see
            // workspace-scoped data on other routes.
            if(localStorageHelper.getCurrentWorkspaceId()){
                localStorageHelper.setWorkspaceContext(null);
                localStorageHelper.setCurrentWorkspaceId(null);
                if(typeof localStorageHelper.setWorkspaceList === "function"){
                    localStorageHelper.setWorkspaceList([]);
                }
            }
            this.view.setWorkspaceOff();
            this.view.hideProjectsBtn();
            this.view.hideTranscribedFilesBtn();
            this.view.hideRecordingsMenuBtn();
            this.view.hideEditHistoryBtn();
            this.view.hideAssetsBtn();
            this.view.hideSharedWithMeMenuBtn();
            this.view.hideWorkspaceSwitcher();
            this.view.showLegacyMenuItems();
            return;
        }

        if(inWorkspace){
            // In workspace context: show only new items, hide all legacy
            // "Shared with me" is personal-space only (shows projects shared across workspaces)
            this.view.showProjectsBtn();
            this.view.showTranscribedFilesBtn();
            this.view.showRecordingsMenuBtn();
            this.view.showEditHistoryBtn();
            this.view.showAssetsBtn();
            this.view.hideSharedWithMeMenuBtn();
            this.view.hideLegacyMenuItems();
        }else{
            // Personal space
            if(isShortcastCreator){
                // Shortcast creator: new items only, no legacy
                this.view.showProjectsBtn();
                this.view.showTranscribedFilesBtn();
                this.view.showRecordingsMenuBtn();
                this.view.showEditHistoryBtn();
                this.view.showAssetsBtn();
                this.view.showSharedWithMeMenuBtn();
                this.view.hideLegacyMenuItems();
            }else if(isLegacyCreator){
                // Journey creator or creator in personal space: new items replace legacy library
                this.view.showProjectsBtn();
                this.view.showTranscribedFilesBtn();
                this.view.showRecordingsMenuBtn();
                this.view.showEditHistoryBtn();
                this.view.showAssetsBtn();
                this.view.showSharedWithMeMenuBtn();
                this.view.hideLegacyMenuItems();
            }else if(isListener){
                // Listener: no new items, only some legacy items
                this.view.hideProjectsBtn();
                this.view.hideTranscribedFilesBtn();
                this.view.hideRecordingsMenuBtn();
                this.view.hideEditHistoryBtn();
                this.view.hideAssetsBtn();
                this.view.hideSharedWithMeMenuBtn();
                this.view.showLegacyMenuItems();
                this.view.hideMyLibrary2Btn();
                this.view.showHomeBtn();
                this.view.hideMyLibraryBtn();
                this.view.hideMyJourneysBtn();
                this.view.showMySubscriptionsBtn();
                this.view.showExploreBtn();
                this.view.showSearchBtn();
            }else{
                // Fallback: treat as shortcast creator
                this.view.showProjectsBtn();
                this.view.showTranscribedFilesBtn();
                this.view.showRecordingsMenuBtn();
                this.view.showEditHistoryBtn();
                this.view.showAssetsBtn();
                this.view.showSharedWithMeMenuBtn();
                this.view.hideLegacyMenuItems();
            }
        }

        // Workspace switcher visibility: hide for pure listeners, but keep it
        // visible for listener-profile users who accepted a workspace invite.
        if(isListener && !this._hasWorkspaceMembershipContext()){
            this.view.hideWorkspaceSwitcher();
        }
    },

    showHelpPage : function(){
        PersistentModels.getInstance().getRouter().showHelpPage(true);
    },

    setAllNotificationRead : function(allNotificationRead){
        this._allNotificationRead =  allNotificationRead;
        this.view.setAllNotificationRead(this._allNotificationRead);
    },

    setUnreadMessagesInHelpSection : function(unreadMessagesInHelpSection){
        this._unreadMessagesInHelpSection =  unreadMessagesInHelpSection;
        this.view.setUnreadMessagesInHelpSection(this._unreadMessagesInHelpSection);
    },


    setHelpDisplayedAtLeastOnceToUser : function(displayOnceToUser){
        this.view.setHelpDisplayedAtLeastOnceToUser(displayOnceToUser);
    },



    showLoggedInUserPage  : function(){
        if(this._userInfo){
            PersistentModels.getInstance().getRouter().showUserProfilePageByUsername(null,this._userInfo.getUserId(), null, true );
        }else{
            TrebbleClientAPIHelper.getInstance().doLoginWithLoginPage().then((function(){
                if(this._userInfo){
                    PersistentModels.getInstance().getRouter().showUserProfilePageByUsername(null,this._userInfo.getUserId(), null, true );
                }
            }).bind(this));
        }
    },

    installChromeExtension : function(){
        PersistentModels.getInstance().getRouter().showChromeExtensionInstallHelperPopup();
    },

    installWPA : function(){
        if(window.installPromptEvent){
            window.installPromptEvent.prompt();
            // Wait for the user to respond to the prompt
            window.installPromptEvent.userChoice.then((function(choice){
                if (choice.outcome === 'accepted') {
                    this.view.hideInstallWPABtn();
                    if(window.trebbleAnalyticsHelper){
                        window.trebbleAnalyticsHelper.trackEvent(GoogleAnalyticsEvents.getInstance().CATEGORY.INSTALL_PROGRESSIVE_WEB_APP.name, GoogleAnalyticsEvents.getInstance().CATEGORY.INSTALL_PROGRESSIVE_WEB_APP.actions.ACCEPTED_PWA_INSTALL.name, GoogleAnalyticsEvents.getInstance().CATEGORY.INSTALL_PROGRESSIVE_WEB_APP.actions.ACCEPTED_PWA_INSTALL.label);
                    }

                } else {
                    this.view.showInstallWPABtn();
                    if(window.trebbleAnalyticsHelper){
                        window.trebbleAnalyticsHelper.trackEvent(GoogleAnalyticsEvents.getInstance().CATEGORY.INSTALL_PROGRESSIVE_WEB_APP.name, GoogleAnalyticsEvents.getInstance().CATEGORY.INSTALL_PROGRESSIVE_WEB_APP.actions.REJECTED_PWA_INSTALL.name, GoogleAnalyticsEvents.getInstance().CATEGORY.INSTALL_PROGRESSIVE_WEB_APP.actions.REJECTED_PWA_INSTALL.label);
                    }
                }
                // Clear the saved prompt since it can't be used again
                window.installPromptEvent = null;
            }).bind(this));
}
},

createMyOwnTrebble :function(){
if(window.trebble.userNeedToRequestAnInviteToSetupTrebble){
this.openRequesInvitePage();
}else{
PersistentModels.getInstance().getRouter().showTrebbleSetupPage(null, true);
}
},

createMyFirstJourney :function(){
return PersistentModels.getInstance().getRouter().showJourneyCreationWizardPage(true, (function(model, action, data){
if(action == "newJourneyInfo" && data){
    return TrebbleClientAPIHelper.getInstance().getUserProfileInfoByUsername(LocalStorageHelper.getInstance().getUserInfo().username).then((function(updatedUserInfo){
        LocalStorageHelper.getInstance().updateUserInfo(updatedUserInfo);
    }).bind(this))
}
}).bind(this));
},

openRequesInvitePage : function(){
const openedWindow = window.open("https://trebble.typeform.com/to/JXo8tX", "_blank");
if((!openedWindow || openedWindow.closed || typeof openedWindow.closed=='undefined') && !window.waitForCordovaToLoad){
window.alertErrorMessage(window.getI18n(ti18n, "PLEASE_ALLOW_POPUPS_FOR_TREBBLE"));
}else{
if(openedWindow.focus){
    openedWindow.focus();
}
}

},

onPanelClosed : function(){
PersistentModels.getInstance().getRouter().updateActivePageHeightToMatchPlayerFooterHeight();
},

onUnreadMessagesInHelpSectionChange : function(unreadMessagesCount){
if(unreadMessagesCount && unreadMessagesCount > 0){
this.view.setUnreadMessagesInHelpSection(true);
}else{
this.view.setUnreadMessagesInHelpSection(false);
}

},

showUpgradeToPaidSubscriptionPopup: function() {
    if (WORKSPACE_ENABLED) {
        if (!shouldShowUpgradeCTA()) {
            return;
        }
        var mode = getRecommendedUpgradeMode();
        PersistentModels.getInstance().getRouter().showUpgradeToTeamPopup(this, { mode: mode });
    } else {
        PersistentModels.getInstance().getRouter().showUpgradeToPaidSubscriptionPopup();
    }
},


buildModelAndRenderView : function() {

return new RSVP.Promise((function(resolve, reject) {
try {
    const params = {};
    params.userInfo = this._userInfo;
    //TODO: This is experimental and has only be added for the webby awards entry. This should be removed after.
    params.isUserAllowToSetupTrebble = this._userInfo? this._userInfo.getProfileType() != Utils.getInstance().getProfileTypes().CREATOR  && !window.waitForCordovaToLoad : false ;//&& LocalStorageHelper.getInstance()  && LocalStorageHelper.getInstance().isUserAllowToSetupATrebble ? LocalStorageHelper.getInstance().isUserAllowToSetupATrebble(): false;
    params.isUserAllowToCreateFirstJourney = this._userInfo? this._userInfo.getProfileType() == Utils.getInstance().getProfileTypes().LISTENER  && !window.waitForCordovaToLoad: false ;//&& LocalStorageHelper.getInstance()  && LocalStorageHelper.getInstance().isUserAllowToSetupATrebble ? LocalStorageHelper.getInstance().isUserAllowToSetupATrebble(): false;
    this.view = new HomeMenuPanelView(params);
    this.view.render();
    this.listenTo(this.view,"showGlobalSearch",this.showGlobalSearch);
    this.listenTo(this.view,"showHelpAndFeedback",this.showHelpAndFeedback);
    this.listenTo(this.view,"showOnAirPage",this.showOnAirPage);
    this.listenTo(this.view,"showLibraryPage",this.showMyLibrary);
    this.listenTo(this.view,"showLibrary2Page",this.showMyLibrary2);
    this.listenTo(this.view,"showTranscribedFilesPage",this.showTranscribedFiles);
    this.listenTo(this.view,"showEditHistoryPage",this.showEditHistory);
    this.listenTo(this.view,"showReferPage",this.showReferPage);
    this.listenTo(this.view,"showTrebblesPage",this.showMyPersonalRadioDetailPage);
    this.listenTo(this.view,"showSettingsPage",this.showSettingsPage);
    this.listenTo(this.view,"showfeedsAndNotificationPage",this.showfeedsAndNotificationPage);
    this.listenTo(this.view,"showLoggedInUserPage",this.showLoggedInUserPage);
    this.listenTo(this.view,"showHomePage",this.showHomePage);
    this.listenTo(this.view,"showExplorePage", this.showExplorePage);
    this.listenTo(this.view,"showCapsulesPage", this.showCapsulesPage);
    this.listenTo(this.view,"showMySubscriptionsPage", this.showMySubscriptionsPage);
    this.listenTo(this.view,"showMyJourneysPage", this.showMyJourneysPage);
    this.listenTo(this.view,"showSharedWithMePage", this.showSharedWithMePage);
    this.listenTo(this.view,"showHelpPage", this.showHelpPage);
    this.listenTo(this.view, "installChromeExtension", this.installChromeExtension);
    this.listenTo(this.view, "installWPA", this.installWPA);
    this.listenTo(this.view, "showUpgradeToPaidSubscriptionPopup", this.showUpgradeToPaidSubscriptionPopup);
    
    this.listenTo(this.view, "createMyOwnTrebble", this.createMyOwnTrebble);
    this.listenTo(this.view, "createMyFirstJourney", this.createMyFirstJourney);
    this.listenTo(this.view, "showProjectsPage", this.showProjectsPage);
    this.listenTo(this.view, "showAssetsPage", this.showAssetsPage);
    this.listenTo(this.view, "showRecordingsPage", this.showRecordingsPage);
    this.listenTo(this.view, "showCreateWorkspace", this.showCreateWorkspace);

    this.listenTo(this.view, "panelClosed", this.onPanelClosed);
    this.listenTo(this.view, "panelOpened", this._handlePanelOpened);
    if(!DISPLAY_HOME_MENU){
        this.view.hideHomeMenu();
    }
    if(!(ENABLE_JOURNEY_CREATION || LocalStorageHelper.getInstance().isLoggedInUserAJourneyCreator())){
        this.view.hideMyJourneysBtn()
    }
    this.view.setHelpDisplayedAtLeastOnceToUser(LocalStorageHelper.getInstance().isHelpForBloggerDisplayedKey());
    if((!Rollout.isFeatureEnabled(Rollout.FEATURES.ENABLE_INTERCOM_HELP, true)  && !Rollout.isFeatureEnabled(Rollout.FEATURES.USE_ZENDESK_FOR_LIVE_CHAT, true))   || !LiveChatWidgetHelper.getInstance().isAvailable()){
        this.view.hideHelpAndFeedbackMenuBtn();
    }else{
        LiveChatWidgetHelper.getInstance().getUnreadConversationCount().then((function(unreadCount){
            this.onUnreadMessagesInHelpSectionChange(unreadCount);
        }).bind(this))
        this.listenTo(LiveChatWidgetHelper.getInstance(),"unreadMessagesCountChange", this.onUnreadMessagesInHelpSectionChange);
    }
    this.onUserSubscriptionChanged();
    this._checkIfUserHasSharedProjects();
    // Recordings page is part of the teams/workspace rollout — keep the menu
    // entry hidden by default and only surface it where workspaces are
    // enabled, matching the feature gate the backend listRecordings handler
    // ships under.
    if (WORKSPACE_ENABLED && !LocalStorageHelper.getInstance().isLoggedInUserAListener()) {
        this.view.showRecordingsMenuBtn();
    }
    if (WORKSPACE_ENABLED) {
        // Listeners can become workspace editors/reviewers by accepting an
        // invite. Keep the old listener default, but load the switcher
        // whenever a workspace context/list already exists.
        if (!LocalStorageHelper.getInstance().isLoggedInUserAListener() || this._hasWorkspaceMembershipContext()) {
            this._loadWorkspaces();
        }
        // "New Workspace" is now in the workspace switcher dropdown — hide the legacy footer button
        this.view.hideCreateWorkspaceBtn();
    }
    this._updateMenuForUserTypeAndContext();

    //if(!LocalStorageHelper.getInstance().isUserAllowedUserReferral() || !Utils.getInstance().canReferralLinkBeGenerated()){
        if(!Rollout.isFeatureEnabled(Rollout.FEATURES.USER_REFERRAL) || !Utils.getInstance().canReferralLinkBeGenerated()){
            this.view.hideReferUserMenuBtn();
        }else{

            //Refer menu will be enabled
            //const timeLimit = LocalStorageHelper.getInstance().getUserRefferalTimeStringLimit();

            /*const timeLimit =  Rollout.getFeatureVariable(Rollout.FEATURES.USER_REFERRAL, Rollout.FEATURES.USER_REFERRAL.variables.referral_program_time_limit_string);
            const timeLimitDate =  timeLimit? new Date(): null;
            if(!timeLimitDate && moment(new Date()).isAfter(timeLimitDate)){
                this.view.hideReferUserMenuBtn();
            }*/
        }

        resolve();
    } catch (error) {
        reject(error);
    }

}).bind(this));

}

});

export default HomeMenuPanelController;
